import { cn } from "@/lib/utils";

const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/logo.png`;

export function Logo({ size = 40, className, rounded = "rounded-xl" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Amoreska"
      width={size}
      height={size}
      className={cn(rounded, "object-cover ring-1 ring-white/10 shadow-lg shadow-primary/20", className)}
      style={{ width: size, height: size }}
    />
  );
}
